<template>
  <div>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-card class="mx-2 my-2 proposal-card">
            <v-card-title
              class="proposal-card-title justify-space-between align-baseline"
            >
              <div>
                <div class="headline">
                  {{ host | hostSummary }}
                </div>
                <div>{{ host.address }}</div>
              </div>
              <div>
                <a
                  :href="host.externalId"
                  target="_blank"
                  title="Voir l'annonce d'origine"
                >
                  <v-btn icon>
                    <v-icon class="mr-2">visibility</v-icon>
                  </v-btn>
                </a>
              </div>
            </v-card-title>
            <v-tabs grow v-model="tab" class="hidden-print-only">
              <v-tab>Infos</v-tab>
              <v-tab>Environnement</v-tab>
            </v-tabs>
            <div v-if="tab === 0">
              <HostDetails :host="host" />
            </div>
            <div v-if="tab === 1">
              <HostEnvironment
                v-if="host.geoLoc && host.geoLoc.coordinates"
                :geoLoc="host.geoLoc"
              ></HostEnvironment>
              <div v-else>Aucun environnement disponible</div>
            </div>
          </v-card>
        </v-flex>
        <v-flex md6 xs12>
          <div v-viewer>
            <div
              v-viewer="{ movable: false }"
              class="d-flex d-flex-initial mt-1 justify-end"
              style="flex-wrap: wrap"
            >
              <v-card
                class="px-1 py-1 hidden-print-only mr-2 mb-2"
                v-for="url in host.photoUrlEstate"
                style="width: 15vw; height: 15vw; cursor: pointer"
              >
                <img
                  :src="`${apiUrl}/v1/cache/image/${url}.png`"
                  class="mb-2"
                  style="width: 100%; height: 100%; object-fit: cover"
                />
              </v-card>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { API_URL } from "../../../webapp-commons/config";
import { fetchHil } from "../utils";
import HostDetails from "../components/host/HostDetails";
export default {
  components: { HostDetails },
  data() {
    return {
      tab: 0,
      loading: true,
      host: null,
      apiUrl: API_URL
    };
  },

  methods: {
    async reload() {
      const { host_id } = this.$route.params;
      this.host = await (await fetchHil(`/host/${host_id}`)).json();
    }
  },

  async mounted() {
    this.loading = true;
    await this.reload();
    this.loading = false;
  },

  filters: {
    hostSummary({ numberOfRoom, carrez, price }) {
      let data = [];
      if (numberOfRoom != -1) {
        data.push(`${numberOfRoom} pièce${numberOfRoom > 1 ? "s" : ""}`);
      }
      if (carrez != null) {
        data.push(`${carrez}m²`);
      }
      if (price != null) {
        data.push(`${price}€`);
      }
      return data.join(", ");
    }
  }
};
</script>
<style></style>
